const INITIAL_STATE = {
  petList: {},
  addPet: {},
  editPet: {},
  deletePet: {},
  errors: {},
}

const pet = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_DOG_LIST':
    return { ...state, ...INITIAL_STATE, petList: action.data }
  case 'GET_DOG_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_DOG':
    return { ...state, ...INITIAL_STATE, addPet: action.data }
  case 'ADD_DOG_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_DOG':
    return { ...state, ...INITIAL_STATE, editPet: action.data }
  case 'UPDATE_DOG_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_DOG':
    return { ...state, ...INITIAL_STATE, deletePet: action.data}
  case 'DELETE_DOG_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default pet;
